export interface MangaCategory {
  id: string;
  name: string;
  slug: string;
  icon: string;
}

export interface MangaItem {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  rating: number;
  views: string;
  category: string;
  categorySlug: string;
  description: string;
  status: '连载中' | '已完结';
  updateTime: string;
  chapters: MangaChapter[];
  tags: string[];
}

export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  updateTime: string;
}

export interface FAQ {
  question: string;
  answer: string;
}

export interface Testimonial {
  name: string;
  avatar: string;
  comment: string;
  rating: number;
}

export const categories: MangaCategory[] = [
  { id: 'c1', name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { id: 'c2', name: '校园', slug: 'school', icon: 'ri-book-open-line' },
  { id: 'c3', name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { id: 'c4', name: '热血', slug: 'action', icon: 'ri-fire-line' },
  { id: 'c5', name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line' },
  { id: 'c6', name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { id: 'c7', name: '古风', slug: 'historical', icon: 'ri-ancient-gate-line' },
  { id: 'c8', name: '都市', slug: 'urban', icon: 'ri-building-line' },
];

export const mangaList: MangaItem[] = [
  {
    id: 'm1',
    title: '社长大人别碰我',
    author: '柚子茶',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20cover%20illustration%20of%20romance%20genre%2C%20two%20characters%20elegantly%20posed%2C%20soft%20pastel%20pink%20and%20cream%20background%2C%20delicate%20linework%2C%20clean%20composition%2C%20professional%20digital%20art%20style%2C%20minimal%20background%20with%20soft%20gradient&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    rating: 9.5,
    views: '1280万',
    category: '恋爱',
    categorySlug: 'romance',
    description: '身为小职员的林小鹿意外发现公司社长大人竟然是自己的网恋对象！面对高冷社长在现实中的百般刁难，和网络上的温柔体贴，她该如何抉择？一场甜蜜又搞笑的办公室恋爱故事就此展开。',
    status: '连载中',
    updateTime: '2026-08-05',
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: `m1-ch${i + 1}`,
      title: `第${i + 1}话 ${['命运的邂逅', '意外的重逢', '心跳加速', '告白之夜', '新的开始'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(7 - Math.floor(i / 15)).padStart(2, '0')}-${String(30 - i).padStart(2, '0')}`,
    })),
    tags: ['甜宠', '办公室', '霸道总裁', '先婚后爱'],
  },
  {
    id: 'm2',
    title: '剑与魔法学院',
    author: '星河漫画家',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20in%20fantasy%20genre%2C%20magical%20academy%20setting%2C%20young%20wizard%20with%20glowing%20sword%2C%20dramatic%20lighting%2C%20warm%20golden%20and%20amber%20tones%2C%20clean%20minimal%20composition%2C%20professional%20digital%20illustration%20with%20soft%20gradient%20background&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    rating: 9.7,
    views: '2560万',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '普通高中生李昊在一次意外中获得了传说中的魔法之剑，被招入神秘的哈尔蒙尼亚魔法学院。在这里，他将结识各具特色的伙伴，揭开隐藏在学院深处的惊天秘密。',
    status: '连载中',
    updateTime: '2026-08-05',
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: `m2-ch${i + 1}`,
      title: `第${i + 1}话 ${['魔法的觉醒', '学院之门', '剑术大赛', '暗影来袭', '龙之契约'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(7 - Math.floor(i / 20)).padStart(2, '0')}-${String(28 - i).padStart(2, '0')}`,
    })),
    tags: ['热血', '魔法', '学院', '成长'],
  },
  {
    id: 'm3',
    title: '我的同桌是校花',
    author: '小确幸',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20charming%20Korean%20manhwa%20school%20romance%20cover%2C%20two%20high%20school%20students%20sitting%20at%20desk%2C%20cherry%20blossom%20petals%20floating%2C%20warm%20spring%20light%2C%20soft%20pink%20and%20cream%20background%2C%20delicate%20art%20style%2C%20clean%20composition&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    rating: 9.3,
    views: '1890万',
    category: '校园',
    categorySlug: 'school',
    description: '转学生陈逸被安排坐在了全校公认的校花苏晴旁边。原以为会是美好的校园生活，谁知这位校花大人竟然是个超级宅女加游戏狂魔！两个看似不搭的人，在日常相处中慢慢擦出了不一样的火花。',
    status: '连载中',
    updateTime: '2026-08-04',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `m3-ch${i + 1}`,
      title: `第${i + 1}话 ${['转校生', '同桌的你', '秘密暴露', '樱花树下', '心跳的距离'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(7 - Math.floor(i / 12)).padStart(2, '0')}-${String(25 - i).padStart(2, '0')}`,
    })),
    tags: ['青春', '校园', '甜宠', '搞笑'],
  },
  {
    id: 'm4',
    title: '暗夜追踪者',
    author: '墨染工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20mystery%20Korean%20manhwa%20cover%2C%20detective%20character%20in%20trench%20coat%2C%20noir%20atmosphere%2C%20dim%20street%20lamp%20lighting%2C%20moody%20brown%20and%20dark%20warm%20tones%2C%20minimal%20background%2C%20clean%20professional%20digital%20art%20style&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    rating: 9.6,
    views: '3100万',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '连环命案震惊全城，退休刑警韩哲被迫重返岗位。每一个现场留下的暗号，都指向十五年前那场未完结的旧案。当真相一步步浮出水面，韩哲发现自己早已深陷一场精心设计的迷局之中。',
    status: '已完结',
    updateTime: '2026-07-20',
    chapters: Array.from({ length: 95 }, (_, i) => ({
      id: `m4-ch${i + 1}`,
      title: `第${i + 1}话 ${['暗夜降临', '血色密码', '迷雾重重', '破局之刃', '真相大白'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(6 - Math.floor(i / 16)).padStart(2, '0')}-${String(20 - i % 20).padStart(2, '0')}`,
    })),
    tags: ['悬疑', '推理', '犯罪', '反转'],
  },
  {
    id: 'm5',
    title: '天下第一厨神',
    author: '香飘飘',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Korean%20manhwa%20cooking%20comedy%20cover%2C%20cheerful%20young%20chef%20holding%20delicious%20dish%2C%20warm%20orange%20and%20cream%20background%2C%20appetizing%20food%20illustration%2C%20bright%20and%20energetic%20style%2C%20clean%20composition%2C%20professional%20digital%20art&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    rating: 9.1,
    views: '980万',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '外卖小哥王大锤意外获得了一本失传已久的厨神秘籍，从此踏上了一条从街头小摊到米其林三星的逆袭之路。看大锤如何用美食征服世界，顺便收获爱情和友情！',
    status: '连载中',
    updateTime: '2026-08-03',
    chapters: Array.from({ length: 58 }, (_, i) => ({
      id: `m5-ch${i + 1}`,
      title: `第${i + 1}话 ${['厨神秘籍', '初露锋芒', '厨艺大赛', '巅峰对决', '食神降临'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(7 - Math.floor(i / 10)).padStart(2, '0')}-${String(22 - i).padStart(2, '0')}`,
    })),
    tags: ['美食', '搞笑', '热血', '逆袭'],
  },
  {
    id: 'm6',
    title: '凤舞九天',
    author: '水墨丹青',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Korean%20manhwa%20historical%20fantasy%20cover%2C%20elegant%20female%20warrior%20in%20traditional%20hanfu%20style%20dress%2C%20phoenix%20motif%2C%20warm%20coral%20and%20gold%20background%2C%20ethereal%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20illustration&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    rating: 9.8,
    views: '4200万',
    category: '古风',
    categorySlug: 'historical',
    description: '将军之女沈凤歌女扮男装代父从军，在战场上所向披靡。然而一场宫廷阴谋让她家破人亡，重生归来的她誓要揭开真相，让那些背叛者付出代价。权谋、复仇、爱情，一场华丽的古风传奇。',
    status: '已完结',
    updateTime: '2026-06-30',
    chapters: Array.from({ length: 150 }, (_, i) => ({
      id: `m6-ch${i + 1}`,
      title: `第${i + 1}话 ${['凤鸣九霄', '血染沙场', '权谋暗涌', '涅槃重生', '天下归一'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(5 - Math.floor(i / 25)).padStart(2, '0')}-${String(30 - i % 30).padStart(2, '0')}`,
    })),
    tags: ['古风', '权谋', '女强', '复仇'],
  },
  {
    id: 'm7',
    title: '都市灵异事件簿',
    author: '午夜编辑部',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20manhwa%20urban%20supernatural%20cover%2C%20modern%20city%20at%20twilight%20with%20ghostly%20figures%2C%20young%20protagonist%20with%20spiritual%20sight%2C%20moody%20warm%20brown%20and%20amber%20tones%2C%20clean%20minimal%20composition%2C%20professional%20digital%20art&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    rating: 9.4,
    views: '1650万',
    category: '悬疑',
    categorySlug: 'mystery',
    description: '普通上班族赵明在一次加班夜归途中，意外开启了阴阳眼。从此，他的生活发生了翻天覆地的变化——白天是朝九晚五的白领，晚上则成了处理灵异事件的阴阳师。',
    status: '连载中',
    updateTime: '2026-08-04',
    chapters: Array.from({ length: 68 }, (_, i) => ({
      id: `m7-ch${i + 1}`,
      title: `第${i + 1}话 ${['阴阳眼', '第一个委托', '恶灵附身', '都市传说', '阴阳两界'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(7 - Math.floor(i / 11)).padStart(2, '0')}-${String(20 - i).padStart(2, '0')}`,
    })),
    tags: ['灵异', '都市', '悬疑', '搞笑'],
  },
  {
    id: 'm8',
    title: '篮球少年',
    author: '热血工坊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20manhwa%20sports%20cover%2C%20young%20basketball%20player%20jumping%20for%20dunk%2C%20energetic%20action%20pose%2C%20warm%20sunset%20orange%20background%2C%20inspiring%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20illustration%20style&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    rating: 9.2,
    views: '1420万',
    category: '热血',
    categorySlug: 'action',
    description: '身高只有一米七的高中生林风，凭借惊人的弹跳力入选校篮球队。在强者如林的篮球世界里，他用汗水和努力证明，矮个子也能称霸球场！',
    status: '连载中',
    updateTime: '2026-08-03',
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: `m8-ch${i + 1}`,
      title: `第${i + 1}话 ${['奇迹的跳跃', '集训营', '地区大赛', '全国之路', '最终决战'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(7 - Math.floor(i / 10)).padStart(2, '0')}-${String(18 - i).padStart(2, '0')}`,
    })),
    tags: ['运动', '热血', '青春', '校园'],
  },
  {
    id: 'm9',
    title: '重生之商界女王',
    author: '盛世娱乐',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20Korean%20manhwa%20business%20drama%20cover%2C%20confident%20businesswoman%20in%20modern%20office%20setting%2C%20city%20skyline%20background%2C%20warm%20champagne%20and%20cream%20tones%2C%20elegant%20and%20powerful%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20art&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    rating: 9.5,
    views: '2780万',
    category: '都市',
    categorySlug: 'urban',
    description: '前世被渣男和闺蜜联手害死的商界精英苏晚晴，重生回到了十年前。带着前世的记忆和商业头脑，她要在这一世活出精彩，让所有对不起她的人付出代价。',
    status: '连载中',
    updateTime: '2026-08-05',
    chapters: Array.from({ length: 92 }, (_, i) => ({
      id: `m9-ch${i + 1}`,
      title: `第${i + 1}话 ${['重生归来', '步步为营', '商场风云', '以牙还牙', '女王加冕'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(7 - Math.floor(i / 15)).padStart(2, '0')}-${String(28 - i).padStart(2, '0')}`,
    })),
    tags: ['重生', '商战', '女强', '复仇'],
  },
  {
    id: 'm10',
    title: '妖怪公寓的日常',
    author: '奇异果工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20whimsical%20Korean%20manhwa%20fantasy%20comedy%20cover%2C%20cute%20monster%20characters%20living%20in%20modern%20apartment%2C%20warm%20peach%20and%20cream%20background%2C%20playful%20and%20cozy%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20illustration%20style&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    rating: 9.0,
    views: '850万',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '普通大学生陈默租到了一间超级便宜的公寓，入住后才发现这栋楼的住户全都是妖怪！九尾狐房东、河童邻居、雪女室友……一场爆笑又温馨的同居生活就此展开。',
    status: '连载中',
    updateTime: '2026-08-02',
    chapters: Array.from({ length: 45 }, (_, i) => ({
      id: `m10-ch${i + 1}`,
      title: `第${i + 1}话 ${['便宜没好货', '妖怪邻居', '同居法则', '百鬼夜行', '暖心日常'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(7 - Math.floor(i / 8)).padStart(2, '0')}-${String(15 - i).padStart(2, '0')}`,
    })),
    tags: ['搞笑', '奇幻', '日常', '妖怪'],
  },
  {
    id: 'm11',
    title: '恋爱攻略系统',
    author: '星梦社',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20playful%20Korean%20manhwa%20romance%20gaming%20cover%2C%20young%20couple%20with%20game%20interface%20floating%2C%20warm%20pink%20and%20cream%20background%2C%20cute%20and%20modern%20style%2C%20clean%20composition%2C%20professional%20digital%20illustration%20with%20soft%20gradient&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    rating: 9.3,
    views: '1120万',
    category: '恋爱',
    categorySlug: 'romance',
    description: '母胎单身的程序员周子轩意外绑定了恋爱攻略系统，系统要求他必须在三个月内攻略校花。然而系统给出的攻略方式总是让人啼笑皆非，笑料百出的恋爱大作战开始了！',
    status: '连载中',
    updateTime: '2026-08-04',
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `m11-ch${i + 1}`,
      title: `第${i + 1}话 ${['系统绑定', '攻略开始', '好感度UP', '情敌出现', '真心时刻'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(7 - Math.floor(i / 9)).padStart(2, '0')}-${String(18 - i).padStart(2, '0')}`,
    })),
    tags: ['甜宠', '系统', '校园', '搞笑'],
  },
  {
    id: 'm12',
    title: '末日生存手册',
    author: '极光社',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gripping%20Korean%20manhwa%20post%20apocalyptic%20cover%2C%20survivors%20in%20ruined%20city%2C%20dramatic%20warm%20orange%20sunset%20lighting%2C%20intense%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20illustration%20with%20dramatic%20lighting&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    rating: 9.7,
    views: '3650万',
    category: '热血',
    categorySlug: 'action',
    description: '一场突如其来的病毒感染让世界沦为末日废土。普通高中生林晨觉醒了罕见的生存异能，在废墟中组建自己的幸存者团队，在末世中寻找希望和真相。',
    status: '连载中',
    updateTime: '2026-08-05',
    chapters: Array.from({ length: 108 }, (_, i) => ({
      id: `m12-ch${i + 1}`,
      title: `第${i + 1}话 ${['末日降临', '觉醒异能', '废土求生', '安全区', '黎明之前'][i % 5]}`,
      number: i + 1,
      updateTime: `2026-${String(7 - Math.floor(i / 18)).padStart(2, '0')}-${String(30 - i).padStart(2, '0')}`,
    })),
    tags: ['末世', '异能', '生存', '热血'],
  },
];

export const faqList: FAQ[] = [
  {
    question: '韩漫屋上的漫画都是免费的吗？',
    answer: '是的！韩漫屋上的所有漫画均面向用户免费提供在线阅读。我们与多家韩国漫画平台和作者合作，通过正版授权方式为广大漫迷提供优质的阅读体验。部分热门作品可能需要注册账号后解锁全部章节。',
  },
  {
    question: '韩漫屋的漫画多久更新一次？',
    answer: '韩漫屋与韩国漫画平台保持同步更新。热门连载作品通常每周更新1-2话，具体更新频率取决于原作者的更新节奏。您可以将喜欢的漫画加入收藏，更新时我们会第一时间通知您。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '韩漫屋采用响应式设计，完美支持PC端（Windows/Mac）、平板（iPad/Android Pad）和手机端（iOS/Android）的在线阅读。您可以在任何设备上随时随地享受韩漫的乐趣。',
  },
  {
    question: '如何找到我想看的漫画？',
    answer: '您可以通过多种方式找到心仪的漫画：(1) 使用顶部搜索栏直接搜索漫画名称或作者；(2) 通过分类页面按题材浏览；(3) 查看首页的热门推荐和最新更新板块；(4) 按评分、人气等排序筛选。',
  },
  {
    question: '韩漫屋上的漫画是正版吗？',
    answer: '韩漫屋严格遵守版权法规，平台上的所有漫画均通过正规渠道获得作者或版权方的授权。我们致力于为中文读者提供合法、优质的韩漫阅读服务，同时保障创作者的合法权益。',
  },
  {
    question: '可以在韩漫屋上投稿自己的作品吗？',
    answer: '目前韩漫屋主要引进韩国漫画作品。如果您是漫画创作者，欢迎通过"关于我们"页面的联系表单与我们取得联系，我们的编辑团队会认真评估每一份投稿，并在7个工作日内给予回复。',
  },
];

export const testimonials: Testimonial[] = [
  {
    name: '漫画迷小艾',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20girl%20avatar%20portrait%2C%20warm%20tones%2C%20simple%20clean%20background%2C%20professional%20digital%20illustration&width=100&height=100&seq=avatar-01&orientation=squarish',
    comment: '韩漫屋真的是宝藏网站！画质清晰，更新速度也很快。最喜欢在这里看《凤舞九天》，每一话都舍不得看完。',
    rating: 5,
  },
  {
    name: '追漫达人Leo',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20boy%20avatar%20portrait%2C%20warm%20tones%2C%20simple%20clean%20background%2C%20professional%20digital%20illustration&width=100&height=100&seq=avatar-02&orientation=squarish',
    comment: '用了大半年的韩漫屋了，界面简洁流畅，分类也很清晰。每天的更新提醒让我不会错过任何一部喜欢的漫画。',
    rating: 5,
  },
  {
    name: '小甜饼爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=A%20sweet%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20warm%20tones%2C%20simple%20clean%20background%2C%20professional%20digital%20illustration&width=100&height=100&seq=avatar-03&orientation=squarish',
    comment: '甜宠类韩漫的资源超级丰富！《社长大人别碰我》和《恋爱攻略系统》都是我的心头好，推荐给所有喜欢甜甜恋爱故事的小伙伴。',
    rating: 5,
  },
  {
    name: '奇幻控小北',
    avatar: 'https://readdy.ai/api/search-image?query=A%20mysterious%20anime%20style%20boy%20avatar%20with%20glasses%2C%20warm%20tones%2C%20simple%20clean%20background%2C%20professional%20digital%20illustration&width=100&height=100&seq=avatar-04&orientation=squarish',
    comment: '作为一个奇幻迷，韩漫屋的奇幻分类真的让我欲罢不能。《剑与魔法学院》世界观宏大，作画精美，强烈推荐！',
    rating: 5,
  },
];